function prepend(newElement: Node, referenceElement: Node): Node {
    return referenceElement.insertBefore(newElement, referenceElement.firstChild);
}

// ----------------------------------------------------------------------------

export default prepend;
